import { Athlete } from './types/types';

/**
 * Sorts athletes by their number property in ascending order
 * - Numbers are compared numerically (e.g., 1 comes before 2)
 * - Numeric values are prioritized before non-numeric values
 * - Non-numeric values are compared alphanumerically
 * 
 * @param athletesToSort Array of athletes to sort
 * @returns A new sorted array of athletes
 */
export const sortAthletesByNumber = (athletesToSort: Athlete[]): Athlete[] => {
  return [...athletesToSort].sort((a, b) => {
    const numA = parseInt(a.number, 10);
    const numB = parseInt(b.number, 10);
    
    // If both are valid numbers, compare numerically
    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }
    
    // If only one is a valid number, prioritize numbers before strings
    if (!isNaN(numA)) return -1;
    if (!isNaN(numB)) return 1;
    
    // If both are strings, compare alphanumerically
    return a.number.localeCompare(b.number);
  });
}; 